import PropTypes from 'prop-types';
import * as React from 'react';
function SvgInfo24(_ref) {
  let {
    color,
    dataTest,
    ariaLabel
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", {
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    color: color,
    "data-test": dataTest
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 2a8 8 0 100 16 8 8 0 000-16zm1 7v6h-2v-6zm-1-4a1 1 0 110 2 1 1 0 010-2z",
    fill: "currentColor"
  }));
}
SvgInfo24.propTypes = {
  color: PropTypes.string,
  dataTest: PropTypes.string,
  ariaLabel: PropTypes.string
};
export default SvgInfo24;